import React from "react";
import "./Item.css";

/*interface ItemCardClubProps {
  id: number;
  name: string;
  text?: String;
  onClick?: func;
  selected: Boolean;
  tag?: object
}*/

const ItemCardClub = ({ id, name, text, onClick, selected, tag }) => {
  return (
    <div
      className={"ItemCardClub position-relative Item flex-fill flex-md-grow-0 px-0"}
      style={{
        minWidth: "60px",
        minHeight: "58px",
        borderLeft: selected ? "3px solid var(--primary-color)" : "3px solid transparent",
        backgroundColor: selected ? "rgba(var(--primary-color-rgb), 0.12)" : undefined,
      }}
    >
      <div
        className={
          "d-flex flex-row py-1 px-2 align-items-center justify-content-center " +
          (onClick ? "selectable" : "")
        }
        onClick={() => onClick && onClick(id)}
      >
        <div className="d-flex flex-row my-1 w-100 justify-content-center">
          <img
            src={`https://d13e14gtps4iwl.cloudfront.net/u/clubs/${id}/logo.webp?v=63c386597972f1fcbdcef019a7b453c8`}
            alt={`${name} logo`}
            style={{ height: "40px" }}
          />
          {tag && (
            <div
              className="position-absolute primary-color-background text-white py-0 px-1 text-xs"
              style={{ bottom: "0px", right: "0px", opacity: 0.8 }}
            >
              {tag}
            </div>
          )}
        </div>

        {(name || text) && (
          <div className="d-flex flex-column flex-grow-1 ms-1">
            <div className="h6 my-1 d-inline text-truncate">{name}</div>
            <div className="small">{text}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ItemCardClub;
